import React from 'react';
import { decrypt, URL } from '../variables';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from '../actions/AppActions';
import moment from 'moment';
import CandidateLanguageSelector from '../components/CandidateLanguageSelector';
import { getLanguageTexts, getSelectedLanguage } from '../language';
import { CandidateValidationNotice } from '../Home/CandidateUi';

class ChangePassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            faculdade: null,
            token: {},
            loading: false,
            loading_send: false,
            msgErro: '',
            password: '',
            password_confirmation: '',
            password: '',
            redirect: false,
            path: '',
            msgSuccess: '',
            send: false,
            msgErroToken: '',
            selectedLanguage: getSelectedLanguage()
        }

    }

    handleLanguageChange = (event) => {
        this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
    }

    login(event) {
        event.preventDefault();
        this.setState({ loading_send: true, msgErro: '' });
        let faculdade_id = null;
        if (this.state.faculdade != null) {
            faculdade_id = this.state.faculdade.id;
        }
        fetch(`${URL}api/auth/recovery_password?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                // 'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                password: this.state.password,
                password_confirmation: this.state.password_confirmation,
                token: this.props.match.params.token
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    this.setState({ loading: false, loading_send: false, msgErro: erro, refresh: false, loadingMore: false });
                }
                else {
                    this.setState({ loading_send: false, msgSuccess: getLanguageTexts(this.state.selectedLanguage).password_changed_success, send: true, credencial: '' });
                    // localStorage.setItem('token', resp.access_token);
                    // this.props.login({ token: resp.access_token, user: {} });
                    // this.setState({ redirect: true, path: '/home', loading: false });
                    // if (resp.faculdade != null) {
                    //     this.setState({ faculdade: resp.faculdade, loading: false, msgErro: '' });
                    // }
                    // else {
                    //     this.setState({ redirect: true, path: '/', loading: false });
                    // }
                    // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading: false, loading_send: false, msgErro: getLanguageTexts(this.state.selectedLanguage).server_response_error, refresh: false, loadingMore: false });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, loading_send: false, msgErro: getLanguageTexts(this.state.selectedLanguage).internet_connection_error, refresh: false, loadingMore: false });
            });
    }

    get_token(slug) {
        fetch(`${URL}api/auth/get_token/${slug}?v=a`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                // 'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    this.setState({ loading: false, msgErro: erro, });
                }
                else {
                    if (resp.status == false) {
                        this.setState({ loading: false, msgErroToken: getLanguageTexts(this.state.selectedLanguage).invalid_recovery_token });
                    }
                    else {
                        this.setState({ token: resp.token, faculdade: resp.token.faculdade, loading: false, msgErro: '' });

                    }
                    // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).server_response_error, });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).internet_connection_error, });
            });
    }

    componentDidMount() {
        console.log('oiiii')
        const { match: { params } } = this.props;
        window.addEventListener('candidate_language_change', this.handleLanguageChange);
        this.setState({ loading: true, msgErro: '' });
        this.get_token(params.token);
    }

    componentWillUnmount() {
        window.removeEventListener('candidate_language_change', this.handleLanguageChange);
    }


    changeCPF(event) {
        let text = event.target.value
        let final_num = '';

        if (text.length > 0) {
            text = text.replace('.', '').replace('-', '').replace('.', '');
            if (text.length <= 11) {


                for (let i = 0; i < text.length; i++) {
                    if (!isNaN(text[i])) {
                        if (i == 3) {
                            final_num += '.' + text[i];
                        }
                        else if (i == 6) {
                            final_num += '.' + text[i];
                        }
                        else if (i == 9) {
                            final_num += '-' + text[i];
                        }
                        else {
                            final_num += text[i] + '';
                        }
                    }
                }
                // this.setState({ cpf: final_num });
                this.setState({ credencial: final_num })
            }

        }
        else {
            this.setState({ credencial: final_num })
        }


    }

    changeEmail(event) {
        let text = event.target.value
        let final_num = '';
        final_num = text;
        this.setState({ credencial: final_num })
    }

    changeCPFEmail(event) {
        let text = event.target.value
        let final_num = '';
        if (text.length > 0 && isNaN(text[0])) {
            final_num = text;
            this.setState({ credencial: final_num })
        }
        else if (text.length > 0) {
            text = text.replace('.', '').replace('-', '').replace('.', '');
            if (text.length <= 11) {


                for (let i = 0; i < text.length; i++) {
                    // if (Number.isInteger(text[i])) {
                    if (i == 3) {
                        final_num += '.' + text[i];
                    }
                    else if (i == 6) {
                        final_num += '.' + text[i];
                    }
                    else if (i == 9) {
                        final_num += '-' + text[i];
                    }
                    else {
                        final_num += text[i] + '';
                    }
                    // }
                }
                // this.setState({ cpf: final_num });
                this.setState({ credencial: final_num })
            }

        }
        else {
            this.setState({ credencial: final_num })
        }


    }

    changePassword(event) {
        this.setState({ password: event.target.value })
    }

    render() {
        const t = getLanguageTexts(this.state.selectedLanguage);
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                {this.state.loading && <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> <div className="spinner-border text-primary" role="status"  >
                    <span className="sr-only">{t.loading}</span>
                </div></div>}
                {!this.state.loading  && <div className="candidate-login-layout">
                    <section className="candidate-login-panel">
                        <div className="candidate-login-form-wrap">
                                <div className="candidate-login-logo">
                                    <img src={(this.state.faculdade && this.state.faculdade.logo) || require('../assets/images/logo-ontest.png')}
                                        alt={(this.state.faculdade && this.state.faculdade.name) || "OnTest"} />
                                </div>

                                <div className="candidate-login-form">
                                    <span className="candidate-auth-kicker">{t.candidate_environment}</span>
                                    <h1>{t.change_password_title}</h1>
                                    <p>{t.change_password_hint}</p>

                                    <form className="form-horizontal m-t-30" onSubmit={this.login.bind(this)}>

                                        <div className="form-group row candidate-auth-field">


                                            {this.state.msgSuccess != '' && <div className="col-12"><div className="alert alert-success2  alert-dismissible fade show" role="alert">
                                                <button onClick={() => this.setState({ msgSuccess: '' })} type="button" className="close" data-dismiss="alert" aria-label={t.close}>
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <p style={{ margin: 0 }}>{this.state.msgSuccess}</p>
                                            </div></div>}
                                            {<div className="col-12">
                                                <label>{t.new_password} <span>*</span></label>
                                                <input id="password" type="password"
                                                    className="form-control" name="password"
                                                    placeholder={t.type_new_password}
                                                    value={this.state.password} onChange={(e) => this.setState({ password: e.target.value })} required />

                                            </div>}

                                            {<div className="col-12 mt-3">
                                                <label>{t.confirm_password} <span>*</span></label>
                                                <input id="password_confirmation" type="password"
                                                    className="form-control" name="password_confirmation"
                                                    placeholder={t.type_confirm_password}
                                                    value={this.state.password_confirmation} onChange={(e) => this.setState({ password_confirmation: e.target.value })} required />

                                            </div>}


                                        </div>




                                        {this.state.msgErroToken == '' && <div className="form-group row m-t-20 candidate-login-action">
                                            {this.state.msgErro != '' && <div className="col-sm-12">
                                                <CandidateValidationNotice tone="danger">{this.state.msgErro}</CandidateValidationNotice>
                                            </div>}
                                            {this.state.loading_send == false && this.state.send==false && <div className="col-sm-12 text-right">
                                                <button className="btn btn-primary w-md waves-effect waves-light" style={{ backgroundColor: this.state.faculdade != null ? this.state.faculdade.primaria : '' }} type="submit">{t.save_password} <i className="mdi mdi-arrow-right"></i></button>

                                            </div>}

                                            {this.state.loading_send == false && this.state.send==true && <div className="col-sm-12 text-right">
                                                <Link to={'/'+this.state.faculdade.slug+'/login'}><button className="btn btn-primary w-md waves-effect waves-light" style={{ backgroundColor: this.state.faculdade != null ? this.state.faculdade.primaria : '' }} type="button">{t.make_login} <i className="mdi mdi-arrow-right"></i></button></Link>

                                            </div>}
                                            {this.state.loading_send == true && < div className="col-sm-12 d-flex justify-content-center align-items-center">
                                                <div className="spinner-border text-primary" role="status"  >
                                                    <span className="sr-only">{t.loading}</span>
                                                </div></div>}
                                        </div>}
                                        {this.state.msgErroToken != '' && <div className="form-group row m-t-20 candidate-login-action">
                                            <div className="col-sm-12">
                                                <CandidateValidationNotice tone="danger">{this.state.msgErroToken}</CandidateValidationNotice>
                                            </div>
                                        </div>}

                                        <div className="form-group m-t-10 mb-0 row">
                                            <div className="col-12 m-t-20" style={{ textAlign: 'center' }}>

                                                {/* <a href="{{ action('Auth\ForgotPasswordController@showLinkRequestForm',$faculdade->slug) }}">
                                            <i className="mdi mdi-lock"></i>{{ __('Esqueceu sua senha?') }}
                                        </a>  */}
                                                {/* {this.state.faculdade == null && <a href="{{ action('Auth\ForgotPasswordController@showLinkRequestForm','admin') }}">
                                                    <i className="mdi mdi-lock"></i>Esqueceu sua senha?
                                        </a>} */}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="candidate-login-footer">
                                    <p>© {moment().format('YYYY')} OnTest</p>
                                    <CandidateLanguageSelector className="candidate-login-language" />
                                </div>
                        </div>
                    </section>
                    <aside className="candidate-login-visual" style={{ backgroundImage: `url(${require("../assets/images/candidate-access-v2.png")})` }}>
                        <div className="candidate-login-visual-overlay"></div>
                        <div className="candidate-login-visual-copy">
                            <span>ONTEST</span>
                            <h2>{t.login_hero_title}</h2>
                            <p>{t.login_hero_description}</p>
                        </div>
                    </aside>
                </div>}
            </div>
        );
    }


}

const mapsStateToProps = (state) => (
    {
    }
);

export default connect(mapsStateToProps, { login })(ChangePassword);
